export default __webpack_public_path__ + "locales/es/People.json?hash=20ab6da73b02bf81953abb15c224fad7";